import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=4146b71e&"
import script from "./AddUser.vue?vue&type=script&lang=ts&"
export * from "./AddUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports